export const WorkData = [
    {
      company: "Advanced React",
      designation: "Advanced React developer",
      dateJoining: "2022",
      dateEnd: "2028",
      companyLogo: "https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~X57775KT4UJ4/CERTIFICATE_LANDING_PAGE~X57775KT4UJ4.jpeg",
      work: "Create robust and reusable components with advanced techniques and learn different patterns to reuse common behavior Interact with a remote server and fetch and post data via an API Seamlessly test React applications with React Testing Library Integrate commonly used React libraries to streamline your application development",
    },
    {
      company: "React Basics",
      designation: "AZ-900",
      dateJoining: "2023",
      dateEnd: "2025",
      companyLogo: "https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~NPX2QMVQLSCK/CERTIFICATE_LANDING_PAGE~NPX2QMVQLSCK.jpeg",
      work: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet dapibus neque.",
    },
    {
      company: "HTML and CSS in depth",
      designation: "SC-200",
      dateJoining: "2022",
      dateEnd: "2023",
      companyLogo: "https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~BH2DKVF6W7KD/CERTIFICATE_LANDING_PAGE~BH2DKVF6W7KD.jpeg",
      work: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet dapibus neque.",
    },
    {
      company: "Version Control",
      designation: "AZ-104",
      dateJoining: "2022",
      dateEnd: "2023",
      companyLogo: "https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~85PXFEJQCQ6J/CERTIFICATE_LANDING_PAGE~85PXFEJQCQ6J.jpeg",
      work: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet dapibus neque.",
    },
    // Add more entries with Lorem Ipsum text for the new certifications

        {
          company: "Programming with JavaScript",
          designation: "Certificate Title",
          dateJoining: "2023",
          dateEnd: "2024",
          companyLogo: "https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~U5F6Z3WDNKEP/CERTIFICATE_LANDING_PAGE~U5F6Z3WDNKEP.jpeg",
          work: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet dapibus neque.",
        },
        {
          company: "Introduction to Front end development",
          designation: "Certificate Title",
          dateJoining: "2023",
          dateEnd: "2024",
          companyLogo: "https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~PTU6TPKBNDR5/CERTIFICATE_LANDING_PAGE~PTU6TPKBNDR5.jpeg",
          work: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet dapibus neque.",
        },
       
        {
          company: "Crash Course on Python",
          designation: "Certificate Title",
          dateJoining: "2022",
          dateEnd: "2022",
          companyLogo: "https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~UYTDYCQMGXNT/CERTIFICATE_LANDING_PAGE~UYTDYCQMGXNT.jpeg",
          work: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet dapibus neque.",
        },
       
      ];
      
